module.exports = __webpack_public_path__ + "fonts/bold.6506c6c6.woff2";